// extracted by mini-css-extract-plugin
export var completionBody = "_ct-2";
export var completionCard = "_ct-0";
export var completionFooter = "_ct-3";
export var completionTitle = "_ct-1";